import React from 'react';
import { Skeleton, SkeletonText, VStack, HStack, Box } from '@chakra-ui/react';

export const CardSkeleton = () => (
  <Box
    padding="6"
    boxShadow="lg"
    bg="rgba(13, 16, 25, 0.9)"
    borderRadius="xl"
    border="1px solid"
    borderColor="whiteAlpha.200"
  >
    <Skeleton height="200px" />
    <SkeletonText mt="4" noOfLines={4} spacing="4" skeletonHeight="2" />
  </Box>
);

export const GameSkeleton = () => (
  <VStack spacing={8} width="100%">
    <Skeleton height="60px" width="200px" />
    <HStack spacing={4} width="100%" justifyContent="center">
      {[...Array(3)].map((_, i) => (
        <Skeleton key={i} height="150px" width="150px" />
      ))}
    </HStack>
  </VStack>
);

export const WhitePaperSkeleton = () => (
  <VStack spacing={6} width="100%">
    <Skeleton height="100px" width="150px" />
    <Skeleton height="40px" width="80%" />
    <SkeletonText mt="4" noOfLines={6} spacing="4" width="100%" />
    <HStack spacing={4} width="100%" justifyContent="center">
      {[...Array(3)].map((_, i) => (
        <CardSkeleton key={i} />
      ))}
    </HStack>
  </VStack>
);
